<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-dialog v-model="alterarSenhaDialog" max-width="600">
      <v-card>
        <v-card-title color="primary"><span class="headline" style="color: #4a4a4a">{{
          $t('crudUsuarios.form.passwordChange.title') }}</span></v-card-title>
        <v-card-text>
          <v-form ref="formSenha" v-model="formSenhaValidado">
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field v-model="editedItem.senha" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'" :label="$t('crudUsuarios.form.passwordChange.newPassword')"
                  :rules="[validaSenha]" @click:append="show1 = !show1"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field v-model="editedItem.repetirsenha" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'" :label="$t('crudUsuarios.form.passwordChange.repeatPassword')"
                  :rules="[validaRepeticaoSenha]" @click:append="show2 = !show2"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="closeSenhaDialog">{{
            $t('crudUsuarios.form.passwordChange.close') }}</v-btn>
          <v-btn color="primary" class="white--text" @click="alterarSenha">{{
            $t('crudUsuarios.form.passwordChange.change')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudUsuarios.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="warningUnitsDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #e65100">{{ $t('crudUsuarios.messages.systemMessage') }}</span>
        </v-card-title>
        <v-card-text>
          {{ $t('crudUsuarios.messages.nonAdminUnitsWarning') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text" @click="warningUnitsDialog = false">{{
            $t('button.cancel') }}</v-btn>
          <v-btn color="red" class="white--text" @click="confirmSaveWithUnits">{{
            $t('button.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <EnvioCredenciaisDialog
    v-if="user.is_superadmin"
      v-model="credenciaisDialog"
      :token="token"
      :user="user"
      :setup="setup"
      modo-destinatarios="usuarios"
      :usuarios-pre-selecionados="usuariosCredenciaisSelecionados"
      :title="$t('credentials.dialog.title')"
      :groups-label="$t('crudMessages.groups')"
      :receivers-label="$t('credentials.dialog.receivers')"
      :channels-label="$t('credentials.dialog.channels')"
      :template-label="$t('credentials.dialog.template')"
      :template-required-message="$t('credentials.dialog.templateRequired')"
      :code-text="$t('crudTemplatesMensagens.form.fields.code')"
      :no-channels-message="$t('credentials.dialog.noChannels')"
      :cancel-text="$t('button.cancel')"
      :send-text="$t('button.send')"
      @sent="onCredenciaisSent"
    />

    <merus-data-table :headers="headers" :items="usuarios" :mostrar-inativos="mostrarInativos" :loading="loadingtable" :default-multi-sort="defaultSort"
      :loading-text="$t('crudUsuarios.loading')"
      :server-items-length="totalUsuarios" :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy" :server-sort-desc="serverSortDesc"
      @update:options="onTableOptions" @update:filters="onFiltersUpdate"
      show-select
      item-key="id_usuario"
      v-model="selectedUsuarios"
 cod-tabela="USUARIOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('crudUsuarios.title')" :token="token" :items="usuarios"
          :load-items-for-export="loadItemsForExport" background-export
          list-endpoint="getallusuarios"
          :export-filters="searchFilters"
          :export-sort-by="serverSortBy"
          :export-sort-desc="serverSortDesc"
          :export-total="totalUsuarios"
          :selected-ids="selectedUsuariosIds"
          id-field="id_usuario"
          :csv-title="$t('crudUsuarios.title')"
          :csv-headers="headersCSV" :pdf-title="$t('crudUsuarios.title')" :pdf-headers="headers" :pdf-filename="$t('crudUsuarios.title')"
          :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$tc('crudUsuarios.self', 2)"
          endpoint-upload-csv="/api/v1.0/processacsvusuarios/" @saveBulk="saveBulk" hide-search>
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="primary"
                  dark
                  small
                  fab
                  class="mb-2 mr-2"
                  :disabled="selectedUsuarios.length === 0 || !user.is_superadmin"
                  @click="openCredenciaisDialogBulk"
                >
                  <v-icon>mdi-email-lock-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('credentials.sendButton') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:add>
            <v-dialog v-model="dialog" fullscreen max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('crudUsuarios.messages.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                            item-value="id_empresa" clearable :label="$t('crudUsuarios.form.fields.selectCompany')"
                            :rules="[(v) => !!v || $t('crudUsuarios.messages.companyRequired')]"
                            @change="onEmpresaUsuarioChange"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="editedItem.id_perfil_usuario" :items="perfisUsuarios"
                            item-text="descricao_tipo_usuario_translated" item-value="id_perfil_usuario" clearable
                            :label="$t('crudUsuarios.form.fields.selectUserProfile')"
                            :rules="[(v) => !!v || $t('crudUsuarios.messages.userProfileRequired')]"
                            @change="perfilUsuarioChanged"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="editedItem.id_cliente" :items="clientes" item-text="nome_cliente"
                            item-value="id_cliente" clearable :label="$t('crudUsuarios.form.fields.selectClient')"
                            :disabled="isClienteSelectDisabled"></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="editedItem.id_funcionario" :items="motoristasDisponiveis"
                            item-text="label" item-value="id_funcionario" clearable
                            :label="$t('crudUsuarios.form.fields.linkedDriverEmployee')"
                            :disabled="!editedItem.id_empresa"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete
                            v-model="editedItem.id_agencia_emprego"
                            :items="agenciasAtivas"
                            :item-text="agenciaItemText"
                            item-value="id_agencia_emprego"
                            :label="$t('ticketSolicitacaoCandidatos.fields.agencia')"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <MultiplaEscolha
                            ref="unidadesSelect"
                            lazy
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            :max-items="3"
                            v-bind:selected-items.sync="idUnidades"
                          />
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.login" :label="$t('crudUsuarios.form.fields.username')"
                            :rules="[loginRules]" :disabled="disableLogin"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.nome_usuario"
                            :label="$t('crudUsuarios.form.fields.userName')" :rules="[nomeUsuarioRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.email_recuperacao"
                            :label="$t('crudUsuarios.form.fields.recoveryEmail')" prepend-icon="mdi-email" type="email"
                            :rules="[emailRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.telefone"
                            :label="$t('crudUsuarios.form.fields.phone')" prepend-icon="mdi-phone"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="isAtivo" class="ma-2"
                            :label="$t('crudUsuarios.form.fields.active')"></v-switch>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedIndex === -1">
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.senha" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'" :label="$t('crudUsuarios.form.fields.password')"
                            :rules="[validaSenha]" @click:append="show1 = !show1"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.repetirsenha"
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                            :label="$t('crudUsuarios.form.fields.repeatPassword')" :rules="[validaRepeticaoSenha]"
                            @click:append="show2 = !show2"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="teal" @click="openCredenciaisDialogSingle(item)" v-if="user.is_superadmin"
          :disabled="!item.email_recuperacao">mdi-email-lock-outline</v-icon>

        <v-icon small class="mr-2" color="green" @click="editItem(item)"
          :disabled="!canEditUsuario(item)">mdi-pencil</v-icon>

        <v-icon small class="mr-2" color="orange" @click="openAlterarSenhaDialog(item)"
          :disabled="(item.logado == 0 ? false : true) || !canEditUsuario(item)">mdi-key</v-icon>

        <v-icon :disabled="(item.logado == 0 ? false : true) || (!item.can_delete && !user.is_superadmin)" small
          class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>

        <v-icon :disabled="item.logado == 1 ? false : true" small class="mr-2" color="blue"
          @click="logoutUser(item)">mdi-logout</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EnvioCredenciaisDialog from "./Dialogs/EnvioCredenciaisDialog.vue";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";
import EventBus from "../utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import serverTableMixin from "@/mixins/serverTableMixin";
import { buildRequestParams, computePageState, initSortFromDefault, fetchAllServerPagesForExport } from "@/utils/serverTablePagination";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";

export default {
  mixins: [serverTableMixin],
  components: {
    MerusDataTable,
    CadastroToolbar,
    EnvioCredenciaisDialog,
    MultiplaEscolha,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    alterarSenhaDialog: false,
    formSenhaValidado: false,
    search: "",
    showConfirmButton: true,
    formValidado: true,
    formUploadValidado: false, 
    dialog: false,
    operacao: 0,
    isAtivo: true,
    isAdministrador: false,
    isIdClienteDisabled: false,
    confirmDialog: false,
    warningUnitsDialog: false,
    idUnidades: [],
    uploadDialog: false,
    mensagemdialog: "",
    disableLogin: false,
    show1: false,
    show2: false,
    loadingtable: false,
    arquivoCsv: null,
    mensagemUpload: "",
    fimProcesso: false,
    fileLoading: false,
    arquivoLog: null,
    loadingVeiculos: true,
    uploadResultDialog: false,
    showSaveButton: false,
    resultCSV: [],
    usuarios: [],
    totalUsuarios: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    mostrarInativos: false,
    empresas: [],
    perfisUsuarios: [],
    clientes: [],
    funcionarios: [],
    agencias: [],
    editedIndex: -1,
    editedItem: {
      id_usuario: null,
      login: null,
      nome_usuario: null,
      senha: null,
      ativo: null,
      ativo_extenso: null,
      id_empresa: null,
      razao_social: null,
      id_perfil_usuario: null,
      descricao_tipo_usuario: null,
      logado: null,
      logado_extenso: null,
      email_recuperacao: null,
      id_cliente: null,
      id_funcionario: null,
      id_agencia_emprego: null,
      telefone: null,
    },
    deletedItem: {
      id_usuario: null,
      login: null,
      nome_usuario: null,
      senha: null,
      ativo: null,
      ativo_extenso: null,
      id_empresa: null,
      razao_social: null,
      id_perfil_usuario: null,
      descricao_tipo_usuario: null,
      logado: null,
      logado_extenso: null,
      email_recuperacao: null,
      id_cliente: null,
      id_funcionario: null,
      id_agencia_emprego: null,
      telefone: null,
    },
    defaultItem: {
      id_usuario: null,
      login: null,
      nome_usuario: null,
      senha: null,
      ativo: null,
      ativo_extenso: null,
      id_empresa: null,
      razao_social: null,
      id_perfil_usuario: null,
      descricao_tipo_usuario: null,
      logado: null,
      logado_extenso: null,
      email_recuperacao: null,
      id_cliente: null,
      id_funcionario: null,
      id_agencia_emprego: null,
      telefone: null,
    },
    disablePermissionario: true,
    selectedUsuarios: [],
    credenciaisDialog: false,
    usuariosCredenciaisSelecionados: [],
    setup: {
      has_email: 0,
      has_sms: 0,
      has_whatsapp: 0,
      has_google_chat: 0,
    },
  }),
  computed: {
    messageDismissButton() { return this.$t('button.dismiss') },
    messageConfirmButton() { return this.$t('button.confirm') },
    selectedUsuariosIds() {
      return (this.selectedUsuarios || [])
        .map((u) => u && u.id_usuario)
        .filter((id) => id != null && id !== '');
    },
    defaultSort() {
      return [
        { value: 'ativa_extenso', options: { text: this.$t('crudUnidades.sortOptions.descending'), value: -1 } },
        { value: 'login', options: { text: this.$t('crudUnidades.sortOptions.ascending'), value: 1 } }]
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('crudUsuarios.form.title.create') : this.$t('crudUsuarios.form.title.edit');
    },
    motoristasDisponiveis() {
      if (!this.editedItem || !this.editedItem.id_empresa) {
        return [];
      }
      return this.funcionarios.filter(
        (f) => f.categoria_extenso === 'Motorista' && f.id_empresa === this.editedItem.id_empresa
      );
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isFileLoading() {
      return this.fileLoading;
    },
    headersCSV() {
      return [
        { text: this.$t('crudUsuarios.csvHeaders.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('crudUsuarios.csvHeaders.operation'), value: "operacao" },
        { text: this.$t('crudUsuarios.csvHeaders.userId'), value: "id_usuario", error: "error_id_usuario" },
        { text: this.$t('crudUsuarios.csvHeaders.company'), value: "cod_empresa", error: "error_empresa" },
        { text: this.$t('crudUsuarios.csvHeaders.profile'), value: "descricao_tipo_usuario", error: "error_perfil_usuario" },
        { text: this.$t('crudUsuarios.csvHeaders.login'), value: "login", error: "error_login", warning: "warning_login" },
        { text: this.$t('crudUsuarios.csvHeaders.name'), value: "nome_usuario", error: "error_nome_usuario" },
        { text: this.$t('crudUsuarios.csvHeaders.password'), value: "senha", error: "error_senha", mask: "****" },
        { text: this.$t('crudUsuarios.csvHeaders.email'), value: "email_recuperacao", error: "error_email_recuperacao" },
        { text: this.$t('crudUsuarios.csvHeaders.telephone'), value: "telefone", error: "error_telefone" },
        { text: this.$t('crudUsuarios.csvHeaders.active'), value: "ativo", error: "error_ativo" },
        { text: this.$t('crudUsuarios.csvHeaders.clientCode'), value: "cod_cliente", error: "error_cod_cliente" },
        { text: this.$t('crudUsuarios.csvHeaders.agencyCode'), value: "cod_agencia", error: "error_cod_agencia" },
      ];
    },
    helpCSV() {
      return [
        {
          label: this.$t('crudUsuarios.helpCSV.userId.label'),
          description: this.$t('crudUsuarios.helpCSV.userId.description'),
          example: this.$t('crudUsuarios.helpCSV.userId.example'),
          key: "id_usuario"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.companyCode.label'),
          description: this.$t('crudUsuarios.helpCSV.companyCode.description'),
          example: this.$t('crudUsuarios.helpCSV.companyCode.example'),
          key: "cod_empresa"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.userProfile.label'),
          description: this.$t('crudUsuarios.helpCSV.userProfile.description'),
          example: this.$t('crudUsuarios.helpCSV.userProfile.example'),
          key: "descricao_tipo_usuario"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.login.label'),
          description: this.$t('crudUsuarios.helpCSV.login.description'),
          example: this.$t('crudUsuarios.helpCSV.login.example'),
          key: "login"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.userName.label'),
          description: this.$t('crudUsuarios.helpCSV.userName.description'),
          example: this.$t('crudUsuarios.helpCSV.userName.example'),
          key: "nome_usuario"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.password.label'),
          description: this.$t('crudUsuarios.helpCSV.password.description'),
          example: this.$t('crudUsuarios.helpCSV.password.example'),
          key: "senha"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.recoveryEmail.label'),
          description: this.$t('crudUsuarios.helpCSV.recoveryEmail.description'),
          example: this.$t('crudUsuarios.helpCSV.recoveryEmail.example'),
          key: "email_recuperacao"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.phone.label'),
          description: this.$t('crudUsuarios.helpCSV.phone.description'),
          example: this.$t('crudUsuarios.helpCSV.phone.example'),
          key: "telefone"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.active.label'),
          description: this.$t('crudUsuarios.helpCSV.active.description'),
          example: this.$t('crudUsuarios.helpCSV.active.example'),
          key: "ativo"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.clientCode.label'),
          description: this.$t('crudUsuarios.helpCSV.clientCode.description'),
          example: this.$t('crudUsuarios.helpCSV.clientCode.example'),
          key: "cod_cliente"
        },
        {
          label: this.$t('crudUsuarios.helpCSV.agencyCode.label'),
          description: this.$t('crudUsuarios.helpCSV.agencyCode.description'),
          example: this.$t('crudUsuarios.helpCSV.agencyCode.example'),
          key: "cod_agencia"
        }
      ];
    },
    isClienteSelectDisabled() {
      return this.isIdClienteDisabled || (this.editedIndex === -1 && shouldLockClienteOnCreate());
    },
    agenciasAtivas() {
      return (this.agencias || []).filter((a) => a.ativo === 1 || a.ativo === true);
    },
  },
  watch: {
    dialog(val) {
      if (val && this.editedIndex === -1) {
        this.idUnidades = [];
        const scopedId = getScopedClienteIdForCreate();
        if (scopedId != null) {
          this.editedItem.id_cliente = scopedId;
        }
        this.$nextTick(() => {
          this.applySingleEmpresaIfOnlyOption();
          if (this.$refs.unidadesSelect && typeof this.$refs.unidadesSelect.resetData === 'function') {
            this.$refs.unidadesSelect.resetData();
          }
        });
      }
      val || this.close();
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    try {
      this.user = JSON.parse(sessionStorage.getItem("user"));
    } catch (e) {
      this.user = null;
    }
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() { },
  methods: {

    /** Perfil do usuário da linha pode ter can_edit=0 (ex.: Motorista); gestores do mesmo cliente / admin empresa / superadmin editam. */
    canEditUsuario(item) {
      if (!item || !this.user) return false;
      const u = this.user;
      if (item.can_edit == 1 || item.can_edit === true) return true;
      if (Number(u.is_superadmin) === 1 || u.is_superadmin === true) return true;
      if (Number(u.is_administrador) === 1 || u.is_administrador === true) return true;
      if (u.id_cliente != null && item.id_cliente != null && Number(u.id_cliente) === Number(item.id_cliente)) {
        return true;
      }
      return false;
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
    },
    logoutUser(user) {
      var registro = {
        id_usuario: user.id_usuario,
        logado: 0,
        token: null,
      };

      apiController.request(apiController.endpoints.atualizastatus, {
        data: registro,
        silent: true,
        onSuccess: () => {
          EventBus.$emit('show-alert', { tipo: 'success', mensagem: 'Usuário desconectado com sucesso !' });
          this.initialize();
        },
        onError: (e) => {
          console.log(e);
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: 'Erro ao tentar desconectar usuário !' });
        },
      });
    },
    initialize() {
      if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
        const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
        this.serverSortBy = serverSortBy;
        this.serverSortDesc = serverSortDesc;
      }
      this.serverTableLoad();
      this.populaEmpresas();
      this.populaPerfisUsuarios();
      this.populaClientes();
      this.populaFuncionarios();
      this.populaAgencias();
      this.populaSetup();
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        silent: true,
        onSuccess: (response) => {
          if (response.data && response.data[0]) {
            this.setup = Object.assign({}, response.data[0]);
          }
        },
      });
    },
    openCredenciaisDialogBulk() {
      this.usuariosCredenciaisSelecionados = [...this.selectedUsuarios];
      this.credenciaisDialog = true;
    },
    openCredenciaisDialogSingle(item) {
      this.usuariosCredenciaisSelecionados = [item];
      this.credenciaisDialog = true;
    },
    onCredenciaisSent() {
      this.serverTableLoad();
    },
    serverTableLoad(options) {
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalUsuarios,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      apiController.request(apiController.endpoints.getallUsuarios, {
        data: params,
        onSuccess: (response) => {
          const data = response.data;
          const totalNum = data && data.total != null && data.total !== '' ? Number(data.total) : NaN;
          if (data && !Number.isNaN(totalNum) && Array.isArray(data.items)) {
            const dataForPager = { items: data.items, total: totalNum };
            this.usuarios = this.mapUsuariosForDisplay(data.items);
            const updates = computePageState(dataForPager, { page, rowsPerPage, sortByArr, sortDescArr }, state, this.itemsPerPageLastOption);
            this.totalUsuarios = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            this.usuarios = Array.isArray(data) ? this.mapUsuariosForDisplay(data) : [];
            this.totalUsuarios = this.usuarios.length;
          }
          this.loadingtable = false;
        },
        onError: (e) => {
          this.loadingtable = false;
          console.log("ERRO AXIOS");
          console.log(e);
        },
      });
    },
    async loadItemsForExport(onProgress) {
      const selected = this.selectedUsuarios;
      if (selected && selected.length > 0) {
        if (typeof onProgress === "function") onProgress(100);
        return selected.slice();
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallUsuarios,
            { data: params, silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalUsuarios,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        mapItems: (items) => this.mapUsuariosForDisplay(items),
        onProgress,
      });
    },
    mapUsuariosForDisplay(rows) {
      if (!Array.isArray(rows)) return [];
      const t = (key, fallback) => {
        try {
          return (this.$t && this.$t(key)) || fallback;
        } catch {
          return fallback;
        }
      };
      return rows.map(usuario => {
        const translated = translateDbField(
          usuario.translation_key,
          usuario.descricao_tipo_usuario
        );
        return {
          ...usuario,
          descricao_tipo_usuario_translated: translated,
          ativo_extenso: usuario.ativo === 1 ? t('system.yes', 'Sim') : t('system.no', 'Não'),
          logado_extenso: usuario.logado === 1 ? t('system.yes', 'Sim') : t('system.no', 'Não')
        };
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    populaPerfisUsuarios() {
      apiController.request(apiController.endpoints.getallPerfisusuarios, {
        onSuccess: (response) => {
          this.perfisUsuarios = response.data.map(perfil => {
            const translated = translateDbField(
              perfil.translation_key,
              perfil.descricao_tipo_usuario
            );
            return {
              ...perfil,
              descricao_tipo_usuario_translated: translated
            };
          });
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = response.data;
        },
      });
    },
    populaFuncionarios() {
      apiController.request(apiController.endpoints.getallFuncionarios, {
        onSuccess: (response) => {
          this.funcionarios = Array.isArray(response.data) ? response.data : [];
        },
      });
    },
    onEmpresaUsuarioChange() {
      this.editedItem.id_funcionario = null;
    },
    populaAgencias() {
      apiController.request(apiController.endpoints.getallAgenciasemprego, {
        onSuccess: (response) => {
          this.agencias = response.data || [];
        },
      });
    },
    agenciaItemText(item) {
      if (!item) return '';
      const cod = item.cod_agencia != null ? String(item.cod_agencia).trim() : '';
      const nome = item.nome != null ? String(item.nome).trim() : '';
      if (cod && nome) {
        return cod + ' - ' + nome;
      }
      return nome || cod;
    },
    loginRules() {
      if (this.editedItem.login == null || this.editedItem.login == undefined || this.editedItem.login?.length === 0) {
        return this.$t('crudUsuarios.messages.usernameRequired');
      } 

      if (this.editedItem.login.length > 50) {
        return this.$t('crudUsuarios.messages.usernameRequired');
      }

      return true;
    },
    nomeUsuarioRules() {
      if (!validador(this.editedItem.nome_usuario, 1, 200, 1, 1)) {
        return this.$t('crudUsuarios.messages.userNameRequired');
      } else {
        return true;
      }
    },
    emailRules() {
      if (!this.editedItem.email_recuperacao) {
        return true;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.email_recuperacao)) {
        return this.$t('crudUsuarios.messages.validEmailRequired');
      }

      return true;
    },
    emailContactRules() {
      if (!this.editedItem.email) {
        return true;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.email)) {
        return this.$t('crudUsuarios.messages.validEmailRequired');
      }

      return true;
    },
    validaSenha() {
      if (this.editedItem.senha == null) {
        return this.$t('crudUsuarios.messages.passwordRequired');
      } else {
        if (this.editedItem.senha.length === 0) {
          return this.$t('crudUsuarios.messages.passwordRequired');
        } else {
          if (
            !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{12,}$/.test(
              this.editedItem.senha
            )
          ) {
            return this.$t('crudUsuarios.messages.passwordMinRequirements');
          } else {
            return true;
          }
        }
      }
    },
    validaCliente() {
      if (this.isAdministrador) {
        return true;
      } else {
        if (this.editedItem.id_cliente == null) {
          return this.$t('candidate.clientRequired');
        }
      }
    },
    perfilUsuarioChanged() {
      if (this.editedItem.id_perfil_usuario) {
        this.editedItem.descricao_tipo_usuario = this.perfisUsuarios.find(
          (p) => this.editedItem.id_perfil_usuario === p.id_perfil_usuario
        ).descricao_tipo_usuario;
      } else {
        this.editedItem.descricao_tipo_usuario = null;
      }
    },
    isAdministradorChanged() {
      if (this.isAdministrador) {
        this.editedItem.id_cliente = null;
        this.isIdClienteDisabled = true;
      } else {
        this.isIdClienteDisabled = false;
      }
    },
    validaRepeticaoSenha() {
      if (this.editedItem.repetirsenha == null) {
        return this.$t('crudUsuarios.messages.passwordRequired');
      } else {
        if (this.editedItem.senha.length === 0) {
          return this.$t('crudUsuarios.messages.passwordRequired');
        } else {
          if (this.editedItem.senha != this.editedItem.repetirsenha) {
            return this.$t('crudUsuarios.messages.passwordsMustMatch');
          } else {
            return true;
          }
        }
      }
    },
    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.repetirsenha = this.editedItem.senha;
      this.disableLogin = true;
      if (this.editedItem.ativo == 1) {
        this.isAtivo = true;
      } else {
        this.isAtivo = false;
      }
      if (this.editedItem.is_administrador == 1) {
        this.isAdministrador = true;
      } else {
        this.isAdministrador = false;
      }
      this.idUnidades = Array.isArray(item.id_unidades) ? [...item.id_unidades] : [];
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.unidadesSelect && typeof this.$refs.unidadesSelect.setSelectedItems === 'function') {
          this.$refs.unidadesSelect.setSelectedItems(this.idUnidades);
        }
      });
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('crudUsuarios.messages.confirmDelete', { userName: item.nome_usuario });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('crudUsuarios.messages.no');
      this.messageConfirmButton = this.$t('crudUsuarios.messages.yes');
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteUsuario, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.warningUnitsDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isAtivo = true;
        this.idUnidades = [];
        if (this.$refs.unidadesSelect && typeof this.$refs.unidadesSelect.resetData === 'function') {
          this.$refs.unidadesSelect.resetData();
        }
        (this.disableLogin = false),
          (this.show1 = false),
          (this.show2 = false),
          this.$refs.form.resetValidation();
      });
    },
    isEditedUserAdministrador() {
      const idPerfil = this.editedItem && this.editedItem.id_perfil_usuario;
      const perfil = (this.perfisUsuarios || []).find(
        (p) => p && Number(p.id_perfil_usuario) === Number(idPerfil)
      );
      if (perfil) {
        return Number(perfil.is_administrador) === 1 || perfil.is_administrador === true;
      }
      return Number(this.editedItem && this.editedItem.is_administrador) === 1;
    },
    shouldWarnNonAdminUnits() {
      const ids = Array.isArray(this.idUnidades) ? this.idUnidades : [];
      if (ids.length === 0) {
        return false;
      }
      return !this.isEditedUserAdministrador();
    },
    confirmSaveWithUnits() {
      this.warningUnitsDialog = false;
      this.persistUsuario();
    },
    save() {
      this.$refs.form.validate();
      if (!this.formValidado) {
        return;
      }
      if (this.shouldWarnNonAdminUnits()) {
        this.warningUnitsDialog = true;
        return;
      }
      this.persistUsuario();
    },
    persistUsuario() {
      if (this.isAtivo) {
        this.editedItem.ativo = 1;
      } else {
        this.editedItem.ativo = 0;
      }

      const payload = Object.assign({}, this.editedItem, {
        id_unidades: Array.isArray(this.idUnidades) ? this.idUnidades : [],
      });

      if (this.editedIndex == -1) {
        this.operacao = 0;
        apiController.request(apiController.endpoints.insertUsuario, {
          data: payload,
          onSuccess: (response) => {
            this.updateTable(response.data.erro)
          },
        });
      } else {
        this.operacao = 1;
        payload.update = true;
        apiController.request(apiController.endpoints.updateUsuario, {
          data: payload,
          onSuccess: (response) => {
            this.updateTable(response.data.erro);
          },
        });
      }
    },
    updateTable(status) {
      let mensagem = "";
      let tipo = status ? "error" : "success";
      
      if (status) {
        if (this.operacao == 0) {
          mensagem = this.$t('crudUsuarios.messages.errorInclusion');
        } else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudUsuarios.messages.errorUpdate');
          } else {
            mensagem = this.$t('crudUsuarios.messages.errorDeletion');
          }
        }
      } else {
        if (this.operacao == 0) {
          mensagem = this.$t('crudUsuarios.messages.userIncludedSuccess');
        } else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudUsuarios.messages.userUpdatedSuccess');
          } else {
            mensagem = this.$t('crudUsuarios.messages.userDeletedSuccess');
          }
        }
      }
      
      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.initialize();
    },
    openAlterarSenhaDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.alterarSenhaDialog = true;
    },
    closeSenhaDialog() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.alterarSenhaDialog = false;
    },
    alterarSenha() {
      this.$refs.formSenha.validate();
      if (this.formSenhaValidado) {
        apiController.request(apiController.endpoints.alteraSenha, {
          data: this.editedItem,
          onSuccess: (response) => {
            this.alterarSenhaDialog = false;
            this.editedItem = Object.assign({}, this.defaultItem);
            if (response.data.erro) {
              EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('crudUsuarios.messages.errorPasswordChange') });
            } else {
              EventBus.$emit('show-alert', { tipo: 'success', mensagem: this.$t('crudUsuarios.messages.passwordChangedSuccess') });
            }
          },
          onError: () => {
            this.alterarSenhaDialog = false;
          },
        });
      }
    },
    closeUploadDialog() {
      if (this.$refs.formUpload) {
        this.$refs.formUpload.resetValidation();
      }
      this.arquivoCsv = null;
      this.arquivoLog = null;
      this.resultCSV = [];
      this.uploadDialog = false;
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    submitFile() {
      this.$refs.formUpload.validate();
      if (this.formUploadValidado) {
        let formData = new FormData();

        this.mensagemUpload = this.$t('crudUsuarios.messages.loadingFile');
        this.fileLoading = true;
        if (this.arquivoCsv) {
          formData.append("arquivocsv", this.arquivoCsv);
          apiController.request(apiController.endpoints.uploadCsv, {
            data: formData,
            onSuccess: () => {
              this.processaArquivo();
            },
            onError: () => {
              this.fileLoading = false;
            },
          });
        } else {
          console.log("there are no files.");
        }
      }
    },
    processaArquivo() {
      this.mensagemUpload = this.$t('crudUsuarios.messages.processingFile');
      apiController.request(apiController.endpoints.processaCsvusuarios, {
        params: { file: this.arquivoCsv.name },
        onSuccess: (response) => {
          this.mensagemUpload = response.data.error ? this.$t('crudUsuarios.messages.fileProcessedWithErrors') : this.$t('crudUsuarios.messages.fileProcessedSuccess');
          this.fileLoading = false;
          this.fimProcesso = true;
          this.arquivoLog = response.data.arqlog;
          this.resultCSV = response.data.result;
          this.showSaveButton = !response.data.error;
          this.uploadResultDialog = true;
        },
      });
    },
    downloadArquivoLog() {
      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLog) },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLog)); //or any other extension
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    baseName(str) {
      var base = new String(str).substring(str.lastIndexOf("/") + 1);
      return base;
    },
    async saveBulk(rowsFromDialog) {
      const raw =
        Array.isArray(rowsFromDialog) && rowsFromDialog.length > 0
          ? rowsFromDialog
          : this.resultCSV;
      const list = Array.isArray(raw)
        ? raw
        : raw && Array.isArray(raw.items)
          ? raw.items
          : [];
      if (list.length === 0) {
        return;
      }

      const payload = list.map((p) => ({
        operacao: p.operacao || 'INSERT',
        id_usuario: p.id_usuario != null ? p.id_usuario : null,
        login: p.login,
        nome_usuario: p.nome_usuario,
        senha: p.senha,
        ativo: p.ativo,
        id_empresa: p.id_empresa,
        id_perfil_usuario: p.id_perfil_usuario,
        id_cliente: p.id_cliente != null ? p.id_cliente : null,
        id_agencia_emprego: p.id_agencia_emprego != null ? p.id_agencia_emprego : null,
        email_recuperacao: p.email_recuperacao || null,
        telefone: p.telefone != null ? p.telefone : null,
      }));

      try {
        await apiController.request(apiController.endpoints.upsertUsuariosbulk, {
          data: payload,
          silent: true,
          onSuccess: (response) => {
            this.uploadResultDialog = false;
            this.closeUploadDialog();
            this.updateTable(response.data.erro);
          },
          onError: (e) => {
            this.uploadResultDialog = false;
            console.log("ERRO AXIOS");
            console.log(e);
            EventBus.$emit('show-error', { error: e });
          },
        });
      } catch (e) {
        console.log("ERRO AXIOS");
        console.log(e);
        EventBus.$emit('show-error', { error: e });
      }
    },
  },
};
</script>
